import { useGraphqlQuery } from "@harea/component"
import { TTimeOffType } from "@harea/component"
import { TimeOffTypesQuery } from "../views/leaving/query/TimeOffTypesQuery"

export const useTimeOffTypeQuery = (suspense?: boolean) => {
    return useGraphqlQuery<TimeOffTypesQuery, Array<TTimeOffType>>(new TimeOffTypesQuery(), { suspense })
}